export class OrganizationSearchCriteria {
    public customerTypeId = 2;
    public includeInactive = true;
    public organizationName: string;
    public ein: string;
    public customerIdentificationTypeId: number;
    public customerIdentificationValue: string;
    public customerCharacteristicTypeId: number;
    public addressLine1: string;
    public addressLine2: string;
    public city: string;
    public jurisdictionId: number;
    public countyId: number;
    public postalZipCode: string;
    public phoneNumber: string;
    public emailAddress: string;
    public exactSearch = true;
}
